import { render } from "./FlipLimeColada.ce.vue?vue&type=template&id=167075bc"
import script from "./FlipLimeColada.ce.vue?vue&type=script&lang=js"
export * from "./FlipLimeColada.ce.vue?vue&type=script&lang=js"

import _style_0 from "./FlipLimeColada.ce.vue?vue&type=style&index=0&id=167075bc&inline&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__